import { StakeDbDashboardUnstakeItem } from '@/types/stake-db';
import { Tables } from '../../pools/table/Tables';
import { GridColDef } from '@mui/x-data-grid';
import { StakeDbDashboardUnstakeColumns } from '../table/StakeDbColumnsData';
import { Button, Typography } from '@mui/material';
import { now } from '@/lib/dayjs';
import { fontWeight } from '@/theme';

export default function UnstakeList({ list }: { list: StakeDbDashboardUnstakeItem[] | undefined }) {
  if (!list) {
    return <>unstake empty</>;
  }

  const columns: GridColDef[] = [
    ...StakeDbDashboardUnstakeColumns,
    {
      minWidth: 200,
      field: 'shortTxHash',
      headerName: 'hash',
      headerAlign: 'center',
      align: 'left',
      sortable: false,
      renderCell: (params) => (
        <Button color="primary" onClick={() => handleButtonClick(params.row.txHash)}>
          {params.row.shortTxHash}
        </Button>
      ),
    },
  ];

  const handleButtonClick = (aData: string) => {
    const src =
      process.env.NODE_ENV === 'development'
        ? `https://amoy.polygonscan.com/tx/${aData}`
        : `https://polygonscan.com/tx/${aData}`;
    window.open(src);
  };

  return (
    <>
      <Typography variant="h5" fontWeight={fontWeight.Bold} textAlign="left">
        Unstake
      </Typography>
      <Tables list={list} columns={columns} csvName={`stake-db-unstake-${now()}`} />
    </>
  );
}
